import React from 'react';
import { Content, Page } from '@backstage/core-components';
import { Typography, Box, Button, makeStyles } from '@material-ui/core';
import { Lock as LockIcon } from '@material-ui/icons';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '75vh',
    padding: theme.spacing(4),
  },
  card: {
    background: 'linear-gradient(145deg, rgba(255,255,255,0.9) 0%, rgba(250,250,252,0.95) 100%)',
    backdropFilter: 'blur(20px)',
    borderRadius: 24,
    padding: theme.spacing(8, 6),
    maxWidth: 540,
    textAlign: 'center',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.08), 0 0 1px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.8)',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: 4,
      background: 'linear-gradient(90deg, #1a2332 0%, #2d3f5f 100%)',
    },
  },
  iconWrapper: {
    width: 88,
    height: 88,
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      inset: -8,
      borderRadius: '50%',
      background: 'linear-gradient(135deg, rgba(26, 35, 50, 0.1) 0%, rgba(45, 63, 95, 0.1) 100%)',
      animation: '$ripple 3s ease-out infinite',
    },
  },
  '@keyframes ripple': {
    '0%': { transform: 'scale(1)', opacity: 0.6 },
    '100%': { transform: 'scale(1.5)', opacity: 0 },
  },
  title: {
    fontWeight: 600,
    fontSize: '2rem',
    background: 'linear-gradient(135deg, #1a2332 0%, #2d3f5f 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    marginBottom: theme.spacing(2),
    letterSpacing: '-0.02em',
  },
  description: {
    color: 'rgba(0, 0, 0, 0.6)',
    marginBottom: theme.spacing(5),
    fontSize: 15,
    lineHeight: 1.8,
    fontWeight: 400,
  },
  button: {
    textTransform: 'none',
    padding: theme.spacing(1.75, 5),
    fontSize: 15,
    fontWeight: 600,
    borderRadius: 12,
    background: 'linear-gradient(135deg, #1a2332 0%, #2d3f5f 100%)',
    color: '#fff',
    boxShadow: '0 8px 24px rgba(26, 35, 50, 0.35)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 12px 32px rgba(26, 35, 50, 0.45)',
      background: 'linear-gradient(135deg, #0f1823 0%, #1f2d45 100%)',
    },
  },
}));

export const RequestAccessSimplePage = ({ hideRequestAccess = false }: { hideRequestAccess?: boolean }) => {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <Page themeId="tool">
      <Content>
        <Box className={classes.container}>
          <Box className={classes.card}>
            <Box className={classes.iconWrapper}>
              <LockIcon style={{ color: '#1565c0', fontSize: 40 }} />
            </Box>
            <Typography className={classes.title}>
              Access Required
            </Typography>
            <Typography className={classes.description}>
              You don't have permission to access this module. {!hideRequestAccess && 'Request access to continue exploring the COE Marketplace.'}
            </Typography>
            {!hideRequestAccess && (
              <Button
                onClick={() => navigate('/marketplace/request-access')}
                className={classes.button}
                disableElevation
              >
                Request Access
              </Button>
            )}
          </Box>
        </Box>
      </Content>
    </Page>
  );
};
